module.exports = __webpack_public_path__ + "static/media/planta1.8144daee.png";